import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

export function OwnedGroupSelectBox2({ ownedGroups, setTargetGroup }) {
  const handleChange = (event) => {
    let selectedGroupId = event.target.value;
    ownedGroups.forEach((group) => {
      if (group.id == selectedGroupId) {
        setTargetGroup(group);
      }
    });
  };

  let ownedGroupList = null;
  if (ownedGroups != null) {
    ownedGroupList = ownedGroups.map((group, i) => {
      return (
        <MenuItem value={group.id} key={i}>
          {group.Name}
        </MenuItem>
      );
    });
  }

  const isLoading = ownedGroups == null;

  return (
    <FormControl sx={{ m: 1, width: 300 }}>
      <InputLabel id="owned-group-select-helper-label">
        {isLoading ? "読み込み中..." : "グループ"}
      </InputLabel>
      <Select
        labelId="owned-group-select-helper-label"
        id="owned-group-select-helper"
        label="OwnedGroup"
        defaultOpen
        onChange={handleChange}
        size="small"
        disabled={isLoading}
      >
        {ownedGroupList}
      </Select>
    </FormControl>
  );
}

OwnedGroupSelectBox2.propTypes = {
  ownedGroups: PropTypes.object,
  setTargetGroup: PropTypes.any,
};
